import React from 'react';
import Utils from '../../../../../../Utils';

const Row = ({ country, param, showCountry, data, requests, sources }) => {
    const countryTd = showCountry ? <td rowSpan={9}>{country}</td> : null;
    const values = sources.map(source => <td key={source}>{getValue(country, param, data[source])}</td>);
    const total = getTotal(country, param, data, requests, sources);

    return (
        <tr>
            {countryTd}
            <td>{getName(param)}</td>
            {values}
            <td>{total}</td>
        </tr>
    );
};

function getName(param) {
    switch (param) {
        case 'partnerRequests':
        case 'totalPartnerRequests':
            return 'Partner Requests';
        case 'wins':
        case 'totalWins':
            return 'WON';
        case 'cpc':
        case 'avgCpc':
            return 'CPC';
        case 'wins %':
        case 'totalWins %':
            return '% WON';
        case 'clicks':
        case 'totalClicks':
            return 'Clicks';
        case 'impressions':
        case 'totalImpressions':
            return 'Impressions';
        case 'ctr':
        case 'avgCtr':
            return 'CTR';
        case 'eCpm':
        case 'avgECpm':
            return 'eCPM';
        case 'revenue':
        case 'totalRevenue':
            return 'Revenues';
        default:
            return param;
    }
}

function getValue(country, param, data) {
    switch (param) {
        case 'totalWins':
        case 'totalPartnerRequests':
        case 'totalClicks':
        case 'totalImpressions':
        case 'totalRevenue':
        case 'avgCpc':
        case 'avgECpm':
            return data[param];
        case 'avgCtr':
            return `${data[param]}%`;
        case 'ctr':
            return `${data[param][country]}%`;
        case 'cpc':
        case 'eCpm':
            return data[param][country];
        case 'wins %':
            const requests = data.partnerRequests[country];
            const wins = data.wins[country];

            const value = requests && wins ? ( wins / requests ) * 100 : 0;

            return  `${Utils.roundTo3Decimal(value)}%`;
        case 'totalWins %':
            const { totalRequests, totalWins } = data;
            const totalValue = totalRequests ?  ( totalWins / totalRequests ) * 100 : 0;

            return  `${Utils.roundTo3Decimal(totalValue)}%`;
        case 'revenue':
            return data[param][country] ? Utils.roundTo3Decimal(data[param][country]) : '';
        default:
            return data[param] ? data[param][country] : '';
    }
}

function getTotal(country, param, data, requests, sources) {
    switch (param) {
        case 'cpc':
        case 'avgCpc':
        case 'wins %':
        case 'totalWins %':
        case 'avgCtr':
        case 'avgECpm':
            return;
        case 'totalWins':
        case 'totalPartnerRequests':
        case 'totalClicks':
        case 'totalImpressions':
        case 'totalRevenue':
            return sources.reduce((t, source) => {
                const value = data[source][param] ? parseInt(data[source][param]) : 0;
                return t + value;
            }, 0);
        case 'partnerRequests':
            return requests.requests[country];
        default:
            return sources.reduce((t, source) => {
                const value = data[source][param] && data[source][param][country] ? parseInt(data[source][param][country]) : 0;
                return t + value;
            }, 0);
    }
}

export default Row;



// WEBPACK FOOTER //
// ./src/scenes/Bidder2/components/Table/components/Row/index.js